import React, { Component } from 'react';
import yaml from 'js-yaml';
import Fade from 'react-reveal/Fade';

import { buildPath } from '../utils/route_utils.js'
import { updateSEO } from '../utils/seo_utils'

import Navbar from '../components/Navbar'
import AnnouncementBanner from '../components/AnnouncementBanner'
import Breadcrumb from '../components/Breadcrumb'
import Footer from '../components/Footer'

import '../css/BlogPage.css';

class BlogPage extends Component {

  constructor(props) {
    super(props);
    this.navigate = this.navigate.bind(this)
    this.update_lang = this.update_lang.bind(this)
    this.state = {
      lang: this.props.lang,
      posts: [],
      activeCategory: 'all',
      expandedId: null,
      heroTitle: {
        zh: "部落格 & 最新消息",
        en: "Blog & News",
        ja: "ブログ & ニュース"
      },
      categoryLabels: {
        all: { zh: "全部", en: "All", ja: "すべて" },
        "Company News": { zh: "公司消息", en: "Company News", ja: "企業ニュース" },
        "Technology": { zh: "科技小文", en: "Technology", ja: "テクノロジー" }
      }
    };
  }

  componentDidMount() {
    updateSEO('blog', this.state.lang, '/' + this.state.lang + '/blog');
    fetch(process.env.PUBLIC_URL + '/yaml/blog_posts.yaml')
      .then(response => response.text())
      .then(text => {
        const parsed = yaml.load(text);
        if (parsed && parsed.posts) {
          this.setState({ posts: parsed.posts });
        }
      });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  update_lang(newLang) {
    this.props.updateLang(newLang);
  }

  navigate(route) {
    window.location.href = buildPath(this.state.lang, route);
  }

  render() {
    const lang = this.state.lang;
    const filtered = this.state.activeCategory === 'all'
      ? this.state.posts
      : this.state.posts.filter(p => p.category.en === this.state.activeCategory);
    const categories = ['all', 'Company News', 'Technology'];
    const readMoreLabel = { zh: "閱讀更多", en: "Read More", ja: "続きを読む" };
    const collapseLabel = { zh: "收起", en: "Collapse", ja: "閉じる" };

    return (
      <div className={"blog_page " + lang}>
        <AnnouncementBanner lang={lang} />
        <Navbar lang={lang} updateLangFunc={this.update_lang} />
        <Breadcrumb lang={lang} items={[{ label: { zh: "部落格", en: "Blog", ja: "ブログ" } }]} />

        <div className="blog_hero">
          <h1>{this.state.heroTitle[lang]}</h1>
        </div>

        <div className="blog_content_area">
          <div className="blog_category_bar">
            {categories.map(cat => (
              <button
                key={cat}
                className={"blog_cat_btn" + (this.state.activeCategory === cat ? " blog_cat_active" : "")}
                onClick={() => this.setState({ activeCategory: cat })}
              >
                {this.state.categoryLabels[cat] ? this.state.categoryLabels[cat][lang] : cat}
              </button>
            ))}
          </div>

          <div className="blog_posts_grid">
            {filtered.map((post, idx) => (
              <Fade duration={600} delay={100 + idx * 80} key={post.id}>
                <div className="blog_post_card">
                  <div className="blog_post_img" style={{backgroundImage: 'url(' + post.image + ')', backgroundPosition: post.image_position || 'center'}} />
                  <div className="blog_post_body">
                    <span className={"blog_post_category" + (post.category.en === "Technology" ? " blog_post_category_tech" : "")}>{post.category[lang]}</span>
                    <span className="blog_post_date">{post.date}</span>
                    <h3 className="blog_post_title">{post.title[lang]}</h3>
                    <p className="blog_post_excerpt">
                      {this.state.expandedId === post.id ? post.content[lang] : post.excerpt[lang]}
                    </p>
                    <button
                      className="blog_post_readmore"
                      onClick={() => this.setState({
                        expandedId: this.state.expandedId === post.id ? null : post.id
                      })}
                    >
                      {this.state.expandedId === post.id ? collapseLabel[lang] : readMoreLabel[lang]}
                    </button>
                  </div>
                </div>
              </Fade>
            ))}
          </div>
        </div>

        <Footer lang={lang} navigate={this.navigate} />
      </div>
    );
  }
}

export default BlogPage;
